module.exports = __webpack_public_path__ + "img/lu.33083be.svg";